/* src/app/forms/wizard-configuracao/request-type-service/request-type-service.component.scss */
.list-configuration {
  width: 100%;
  max-width: 100%;
  border: solid 1px #ccc;
  min-height: 40px;
  display: block;
  background: white;
  border-radius: 4px;
  overflow: auto;
  padding: 10px;
}
.list-configuration-box {
  padding: 10px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: white;
  cursor: pointer;
}
.request-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  border: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
  position: relative;
  overflow: auto;
}
.request-list-edit-view {
  display: flex;
  flex-direction: row;
  height: 100%;
  border: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 16px;
  margin-top: 10px;
  position: relative;
  overflow-y: auto;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.list-configuration-box:last-child {
  border: none;
}
.list-configuration.cdk-drop-list-dragging .list-configuration-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.list-configuration-placeholder {
  background: #ccc;
  border: dotted 3px #999;
  min-height: 40px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.button-move {
  cursor: move;
  z-index: 10;
}
.button-menu {
  z-index: 10;
}
.add-button {
  position: absolute;
  right: 80px;
  bottom: 40px;
}
.title {
  font-size: 150% !important;
  text-align: center !important;
}
.container-request {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.list-configuration-info {
  padding-left: 10px;
  width: 100%;
  height: 100%;
}
.grid-view {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.panel-list {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  height: 100%;
  width: 30%;
  border-right: solid 1px #ccc;
  position: relative;
  overflow: auto;
  direction: rtl;
}
.panel-list-item {
  padding: 20px 10px;
  border-bottom: solid 1px #ccc;
  position: relative;
  font-weight: 500;
  cursor: pointer;
}
.item-selected {
  background-color: green;
  width: 3px;
  height: 61px;
  right: 0;
  position: absolute;
  top: -1px;
}
.panel-list-item-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 10px;
  border-radius: 4px;
  padding: 10px;
  overflow: auto;
  border: solid 1px #ccc;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
}
.panel-list-item-wrapper-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.info {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  background-color: #FFFFE1;
  font-weight: 300;
  text-align: center;
}
.title-panel {
  width: 100%;
  font-size: large;
  font-weight: 500;
  margin-bottom: 6px;
}
.panel-list-item-form {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  overflow: auto;
  gap: 10px;
}
.vertical-space {
  width: 100%;
  padding-bottom: 8px;
}
.button-panel-list {
  width: 100%;
  height: 40px;
  margin-top: 4px;
}
.header-properties-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
  position: relative;
}
.header-properties-content-header {
  position: absolute;
  top: -11px;
  font-weight: 500;
  font-size: small;
  padding-right: 10px;
  padding-left: 10px;
}
.header-properties-selection {
  width: 100%;
  flex-direction: row;
  display: flex;
  gap: 10px;
  align-items: baseline;
}
.chip-header-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
  position: relative;
}
query-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
}
.more-options {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.more-options-offSet {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 10px;
  gap: 10px;
}
.more-options-offSet-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  gap: 10px;
}
.more-options-offset-double-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 2;
}
.more-options-offset-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}
key-value-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}
sankhya-query {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 1px;
}
data-save-configuration {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 1px;
}
.query-text {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 6px;
}
.query-text-div {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
.customtextarea {
  min-height: 200px !important;
}
d-para-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 1px;
}
data-transform {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 1px;
}
/*# sourceMappingURL=request-type-service.component.css.map */
